import React from "react";
import AttendanceMap from "./AttendanceMap";
import CustomSearch from "../../../../../components/SearchSimples/CustomSearch";
import {Box} from "@mui/material";
import DisplayView from "../../../../../components/DisplayView";
import {IconMapButton, SearchAdvanceIcon} from "../../../../../components/buttons/IconButtons";
import CustomDateTimePicker from "../../../../../components/CustomDateTimePicker";
import {AttendanceCurrentMapApp} from "../Functionality/AttendanceCurrentMapApp";
import {CustomSelect} from "../../../../../components/CustomSelect";
import AttendanceDetailModal from "./AttendanceDetailModal";
import ButtonAction from "../../../../../components/buttons/ButtonAction";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const AttendanceCurrentMap = ({view, handleView ,option}) => {

    const {
        item,
        searchLocation,
        setSearchLocation,
        elementRef,
        handleChange,
        disabled,
        emptyFields,
        minEndDate,
        departments,
        employees,
        selectEmployee,
        setSelectEmployee,
        t,
        direction,
        setShowDetailsModal,
        showDetailModal,
        handleSearch,
        locations,
        idEmployee,
        dispatch,
        attendanceEmployee,
        setAttendanceEmployee,
        setIdEmployee,
        attendanceByDepartment,
        attendanceByEmployee,
        bodyDepartment,
        loadingMore,
        listContainerRef,
        searchType,
        handleMapMove,
        getActionsButtons,
        cleanAutocompleteSearch,
        setCleanAutocompleteSearch
    } = AttendanceCurrentMapApp({option})

    return (
        <>
            <div className={'d-flex'}>
                {view && handleView &&
                    <DisplayView view={view} setView={handleView} iconRight={IconMapButton} className={'m-0'}/>
                }
                <div className='w-100 ml-2'>
                    <CustomSearch id={'txt_cm_search'}
                                  label={"search_a_place"}
                                  value={searchLocation}
                                  setValue={setSearchLocation}
                                  onChange={(e) => setSearchLocation(e.target.value)}
                    />
                </div>
            </div>
            <div className={"row mt-4 p-0 m-0"}>
                <Box className='col-sm-12 col-md-12 col-lg-4 col-xl-4 p-0'>
                    <CustomSelect id={"slt_acm_department"}
                                  name={"departmentId"}
                                  value={item?.departmentId}
                                  keyName="id"
                                  onChange={handleChange}
                                  list={departments}
                                  trans={"department"}
                                  label={"lbl_acm_department"}
                                  required={true}
                                  showNoSelectionOption={false}
                    />
                </Box>
                <Box className='col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                    <CustomDateTimePicker
                        id={'dp_acm_start_date'}
                        name={'startDate'}
                        disabled={disabled}
                        onChange={(e) => {
                            handleChange({target: {value: e, name: 'startDate'}});
                        }}
                        trans={'start_date_at_time'}
                        value={item?.startDate}
                        required={true}
                        openTo={'day'}
                        emptyFields={emptyFields}
                    />
                </Box>
                <Box className='col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                    <CustomDateTimePicker
                        id={'dp_acm_end_date'}
                        name={'endDate'}
                        onChange={(e) => {
                            handleChange({target: {value: e, name: 'endDate'}});
                        }}
                        disabled={!item?.startDate}
                        trans={'end_date_at_time'}
                        value={item?.endDate}
                        required={true}
                        openTo={'day'}
                        emptyFields={emptyFields}
                        minDateTime={minEndDate}
                    />
                </Box>
                <Box className='col-sm-12 col-md-12 col-lg-2 col-xl-2 p-0'>
                    <ButtonAction
                        id={"btn_acm_search"}
                        name='search'
                        className='btn-icon-search w-100'
                        Icon={SearchAdvanceIcon}
                        onClick={handleSearch}
                        splitName={false}
                        disabled={!item?.departmentId}
                    />
                </Box>
            </div>

            <div ref={elementRef} className='panelTables'>
                <AttendanceMap
                    searchLocation={searchLocation}
                    handleChange={handleChange}
                    item={item}
                    options={employees}
                    t={t}
                    direction={direction}
                    setIdEmployee={setIdEmployee}
                    setShowDetailsModal={setShowDetailsModal}
                    locations={locations}
                    attendanceByDepartment={attendanceByDepartment}
                    attendanceByEmployee={attendanceByEmployee}
                    dispatch={dispatch}
                    selectEmployee={selectEmployee}
                    setSelectEmployee={setSelectEmployee}
                    emptyFields={emptyFields}
                    employees={employees}
                    option={option}
                    bodyDepartment={bodyDepartment}
                    handleSearch={handleSearch}
                    loadingMore={loadingMore}
                    listContainerRef={listContainerRef}
                    searchType={searchType}
                    handleMapMove={handleMapMove}
                    getActionsButtons={getActionsButtons}
                    cleanAutocompleteSearch={cleanAutocompleteSearch}
                    setCleanAutocompleteSearch={setCleanAutocompleteSearch}
                />
            </div>

            <AttendanceDetailModal
                t={t}
                show={showDetailModal}
                onHide={() => {setShowDetailsModal(false);}}
                id={idEmployee}
                dispatch={dispatch}
                attendanceEmployee={attendanceEmployee}
                setAttendanceEmployee={setAttendanceEmployee}
            />

        </>
    )
}

export default AttendanceCurrentMap
